import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css
import '@/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/config/init.js'

import App from './App'
import router from './router'
import store from './store'
import { oauthLogin } from '@/utils/oauth'

import i18n from './lang' // Internationalization
import './icons' // icon

import VueClipboard from 'vue-clipboard2'

import * as filters from './filters' // global filters
import * as directive from '@/directive'
import "@/directive/emoji.js"
import moment from 'moment'
Vue.prototype.$moment = moment
VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);
Vue.use(Element, {
  size: 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
});

Object.keys(directive).forEach(key => {
  Vue.directive(key, directive[key])
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
window.$store=window.store;

require("./others/index");


Vue.config.productionTip = false;

router.beforeEach(async(to, from, next) => {
  const token = $.cookie('Admin-Token')
  if (token) {
    await store.dispatch('userinfo/loginBySso', { access_token: token })
  }
  const hasToken = localStorage.getItem('token') != null 
  if (hasToken) {
    const hasUserInfo = store.state.userinfo.userInfo && Object.keys(store.state.userinfo.userInfo).length !== 0
    if(hasUserInfo) {
      if(to.query.fromData){
        sessionStorage.setItem(`${from.name}`, JSON.stringify(to.query.fromData))
        next()
      }if(to.params.fromData){
        sessionStorage.setItem(`${from.name}`, JSON.stringify(to.params.fromData))
        next()
      }else{
        next()
      }
    } else {
      await store.dispatch('userinfo/getUserInfoBySso')    
      if (to.path === '/dashboard') {
        next({ ...to, replace: true, query: {}})
      } else {
        next({ ...to, replace: true })
      }
    }
  } else {
    oauthLogin()
  }
})

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js